import NavBar from "@/components/site/NavBar";
import HeroVSL from "@/components/site/HeroVSL";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

const DIVORCE_VIDEO_ID = "6a59cf57d8f4fab17740c91c";

const headline = (
  <>
    Your marriage may be ending.{" "}
    <span className="italic text-teal">Your life is not.</span>
  </>
);

const subhead = (
  <>
    <span className="text-ink font-medium">Binoye Jos, Esq.</span> built this
    firm after hiring two prominent law firms, spending{" "}
    <span className="text-ink font-medium">$400,000</span>, and being told
    he&rsquo;d never get equal custody of his son. He fired them, represented
    himself, and won equal custody. He knows what&rsquo;s at stake when your
    finances, your home, and your children&rsquo;s future are all on the table
    at once.
  </>
);

export default function DivorceVSL() {
  return (
    <main data-testid="divorce-vsl-page" className="relative bg-paper text-ink">
      <NavBar />
      <HeroVSL
        videoId={DIVORCE_VIDEO_ID}
        headline={headline}
        subhead={subhead}
      />
      <AttorneyBar />
      <FearSection />
      <FounderStory />
      <GoogleReviews />
      <Testimonials />
      <FinalCTA source="Divorce VSL" />
      <Footer />
    </main>
  );
}
